import React, { FC } from "react";
import { Helmet } from "react-helmet";
import Pagination from "shared/Pagination/Pagination";
import HeaderFilterSearchPage from "components/HeaderFilterSearchPage";
import CardAuthorBox3 from "components/CardAuthorBox3/CardAuthorBox3";

export interface PageChilePyme {
  className?: string;
}

const PageChilePyme: FC<PageChilePyme> = ({ className = "" }) => {
  return (
    <div className={`nc-PageSearch  ${className}`} data-nc-id="PageSearch">
      <Helmet>
        <title>BecauseYes | Pymes chilenas en IE</title>
        <meta name="description" content="BecauseYes, Bienvenidos a nuestro equipo 
        de programadores altamente calificados y dedicados a llevar tus ideas 
        a la vida digital. Somos un conjunto apasionado de profesionales 
        que combinan conocimientos técnicos avanzados con una creatividad sin límites."/>
        
        <meta name="keywords" content="pymes,Chile, chilenos, chilenas, Dublin, Irlanda, Ireland, contador, contabilidad, 
        hardware, mantenimiento, community manager, redes, redes sociales porque si, 
        BecauseYes, Because Yes, becauseyes, because yes, crea tu sitio web, sitio web, 
        customización, servicios, ventajas, planes y suscripciones, mantención web, 
        hosting, certificado ssl, diseño responsive, SEO, posicionamiento SEO,
        cómo funciona, how work, contacta, plan custom, plan standard, plan premium, servicios externos,
        servicio contabilidad, servicio markenting, servicio diseño, descuentos,
        registrate. " />

        <link rel="canonical" href="https://becauseyes.cl/" />
        <meta name="robots" content="follow" />
        <meta name="author" content="BecauseYes"/>
        <meta name="publisher" content="BecauseYes"/>
      </Helmet>
        <header className="text-center max-w-2xl mx-auto mt-14 mb-8" id="">
            <div className="flex flex-col sm:flex-row items-center ">
                <div className="flex flex-row gap-x-2">
                    <span className="sm:hidden mr-2 text-4xl md:text-6xl leading-none">🇨🇮</span>
                    <span className="mr-2 text-4xl md:text-6xl leading-none">🇨🇱</span>
                </div>
                <h2 className=" text-3xl leading-[115%] md:text-5xl md:leading-[105%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                    Pymes chilenas en Dublin
                </h2>
                <span className="hidden sm:block mr-2 text-3xl md:text-6xl leading-none">🇨🇮</span>
            </div>
 
          <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
            Pymes que se adaptan a las necesidades que requieras.
          </span>
        </header>
      <div className="container py-16 lg:pb-20 lg:pt-14 space-y-16">
        <main>
          {/* FILTER */}
          <HeaderFilterSearchPage />

          {/* LOOP ITEMS */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-5 lg:mt-10">
            <CardAuthorBox3/>   
          </div>

          {/* PAGINATION */}
          <div className="flex flex-col mt-12 lg:mt-16 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row sm:justify-between sm:items-center">
            <Pagination />
          </div>
        </main>
      </div>
    </div>
  );
};

export default PageChilePyme;
